import BaseService from "./base.service";

export default class ComunityAllService extends BaseService {
	constructor() {
		super(`comunidade/todos-topicos`);
	}
}
